import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'vsnumber' })
export class VsNumberPipe implements PipeTransform {
    transform(value: any, decimal: any): string {
        // value = '150.000.000.000';
        if (value == null) return value;

        value = parseFloat(value).toFixed(decimal)  // decimal: dùng mấy số sau thập phân

        let list = value.toString().split('.');
        // Nếu là số thập phân
        if (list.length > 1) {
            let first = list[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.').replace(",", ".");

            // Nếu là số nguyên thì trả về số nguyên, ngược lại thì trả về số thập phân
            if (list[1] == 0)
                return first;
            return first + "," + list[1];
        }
        else
            return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.').replace(",", ".");
    }
}

// Cách dùng: {{item.price | vsnumber : 2 }}